import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  items: {}, // { [plantId]: { ...plant, quantity } }
  totalCount: 0,
  totalPrice: 0,
};

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    addToCart(state, action) {
      const plant = action.payload;
      if (!state.items[plant.id]) {
        state.items[plant.id] = { ...plant, quantity: 1 };
        state.totalCount += 1;
        state.totalPrice += plant.price;
      }
    },
    increase(state, action) {
      const id = action.payload;
      if (state.items[id]) {
        state.items[id].quantity += 1;
        state.totalCount += 1;
        state.totalPrice += state.items[id].price;
      }
    },
    decrease(state, action) {
      const id = action.payload;
      if (state.items[id] && state.items[id].quantity > 1) {
        state.items[id].quantity -= 1;
        state.totalCount -= 1;
        state.totalPrice -= state.items[id].price;
      }
    },
    remove(state, action) {
      const id = action.payload;
      if (state.items[id]) {
        state.totalCount -= state.items[id].quantity;
        state.totalPrice -= state.items[id].quantity * state.items[id].price;
        delete state.items[id];
      }
    },
    clearCart(state) {
      state.items = {};
      state.totalCount = 0;
      state.totalPrice = 0;
    },
  },
});

export const { addToCart, increase, decrease, remove, clearCart } = cartSlice.actions;
export default cartSlice.reducer;

